export default __webpack_public_path__ + "static/media/web_login.2f5c4d27.jpg";